import { RoleInputFilter } from "domain/models/role-input-filter";
import Spinner from "presentation/components/Shared/Spinner";
import TimesheetGrid from "presentation/components/Timesheet/TimesheetGrid";
import TimesheetSetting from "presentation/components/Timesheet/TimesheetSetting";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useRoleByFilter } from "presentation/hooks/use-query-role";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useMemo } from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";

const TimesheetGridPage = ({ children }: { children?: React.ReactNode }) => {
  const rolesAllowed = ["CEO", "Finanças", "Admin", "RH"];
  const { isLoading: isPermissionLoading } = usePermissionCheck({
    requiredFunction: "timesheets",
  });
  const { userPermissions } = useAuthStore();
  const { data: rolesData, isLoading: areRolesLoading } = useRoleByFilter({
    limit: 100,
  } as RoleInputFilter);

  const hasAdminTabPermission = useMemo(() => {
    if (!rolesData?.data || !userPermissions) {
      return false;
    }
    const allowedRoleIds = rolesData.data
      .filter((role) => rolesAllowed.includes(role.name))
      .map((role) => role.id);

    return userPermissions.some((permission) =>
      allowedRoleIds.includes(permission.roleId)
    );
  }, [rolesData, userPermissions]);

  if (isPermissionLoading || areRolesLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title="Mapa de Horas" />
      <TabView>
        <TabPanel header="Mapa de Horas" leftIcon="pi pi-clock mr-2">
          <TimesheetGrid />
        </TabPanel>
        {hasAdminTabPermission && [
          <TabPanel
            key="admin-settings"
            header="Administração"
            leftIcon="pi pi-cog mr-2"
          >
            <TimesheetSetting />
          </TabPanel>,
        ]}
      </TabView>
    </div>
  );
};

export default TimesheetGridPage;
